/** Display-only calculation. Every mutation must use a fresh server quote. */
// PLANOS_SIGMA_2810 (GROK2): schema 2 = +step_credits a cada screen_step telas acima das incluídas (máx. max_screens).
const whole = (n, min, max) => Number.isInteger(n) && n >= min && n <= max;
// MEIO_CREDITO_2810 (GROK2): créditos aceitam múltiplos de 0,5 (ex.: 15 DIAS = 0,5).
const credit = (n, max) => typeof n === 'number' && Number.isInteger(n * 2) && n >= 0.5 && n <= max;
/** Formata créditos no padrão BR: 0,5 · 1 · 1,5 */
export const fmtCredits = (n) => { const v = Number(n); return Number.isFinite(v) ? (Math.round(v * 2) / 2).toLocaleString('pt-BR', { maximumFractionDigits: 1 }) : '—'; };

function validPolicy(policy) {
  if (!policy || !credit(policy.base_credits, 10000) || !whole(policy.duration_days, 1, 3650)
    || !whole(policy.included_screens, 1, 12) || policy.extra_screen_credits !== 1) return false;
  if (policy.schema === 1) return true;
  return policy.schema === 2 && whole(policy.screen_step, 1, 12) && credit(policy.step_credits, 10000)
    && whole(policy.max_screens, policy.included_screens, 12);
}

function extraCost(policy, totalScreens) {
  const extras = Math.max(0, totalScreens - policy.included_screens);
  if (policy.schema === 2) return Math.ceil(extras / policy.screen_step) * policy.step_credits;
  return extras * policy.extra_screen_credits;
}

/** Telas que o vendedor pode escolher (schema 2: 4, 6, 8…). */
export function planScreenChoices(policy, technicalCap = 12) {
  if (!validPolicy(policy) || policy.schema !== 2) return null;
  const out = [];
  for (let n = policy.included_screens; n <= Math.min(policy.max_screens, technicalCap); n += policy.screen_step) out.push(n);
  return out;
}

export function creditConfirmation(policy, screens) {
  const quote = planCreditQuote(policy, Number(screens), 12);
  return quote ? { policy, total_screens: quote.totalScreens, total_credits: quote.totalCredits } : null;
}

export function planCreditQuote(policy, totalScreens, technicalCap) {
  if (!validPolicy(policy) || !whole(technicalCap, 1, 12)
    || !whole(totalScreens, 1, technicalCap) || policy.included_screens > technicalCap
    || (policy.schema === 2 && totalScreens > policy.max_screens)) return null;
  const additionalScreens = Math.max(0, totalScreens - policy.included_screens);
  const additionalCredits = extraCost(policy, totalScreens);
  return {
    includedScreens: policy.included_screens,
    totalScreens,
    additionalScreens,
    baseCredits: policy.base_credits,
    additionalCredits,
    totalCredits: policy.base_credits + additionalCredits,
  };
}

export function screenChangeQuote(policy, currentScreens, totalScreens, technicalCap) {
  const next = planCreditQuote(policy, totalScreens, technicalCap);
  if (!next || !whole(currentScreens, 1, 12)) return null;
  const previousExtras = Math.max(0, currentScreens - policy.included_screens);
  const chargeNow = policy.schema === 2
    ? Math.max(0, next.additionalCredits - extraCost(policy, currentScreens))
    : Math.max(0, next.additionalScreens - previousExtras);
  return { ...next, chargeNow, refundCredits: 0, renewalCredits: next.totalCredits };
}
